export default __webpack_public_path__ + "2d910412de078a21f712e3ad7308053d.webp";